export default "/images/vendor/flag-icon-css/flags/1x1/ch.svg?92ba1dfda8b64cee678fa27ca8abd3ba";